"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarGroup = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common/avatar/avatar");
require("@/components/common/avatar/semantics/user-avatar");
require("@/components/common/text/text");
let AvatarGroup = class AvatarGroup extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.avatars = [];
        this.label = '';
        /** 노출할 최대 아바타 수 (나머지는 +N으로 묶음) */
        this.maxVisible = 3;
    }
    render() {
        const overflowCount = this.avatars.length - this.maxVisible;
        return (0, lit_1.html) `
      <div class="avatars">${this.renderAvatarList(overflowCount)}</div>
      ${this.renderLabel()}
    `;
    }
    renderAvatarList(overflowCount) {
        return [this.renderAvatars(), this.renderOverflow(overflowCount)];
    }
    renderAvatars() {
        return this.avatars.slice(0, this.maxVisible).map(avatar => this.renderAvatar(avatar));
    }
    renderAvatar({ name, src }) {
        return (0, lit_1.html) `
      <mm-user-avatar size="32" .name=${name ?? ''} .src=${src}></mm-user-avatar>
    `;
    }
    renderOverflow(overflowCount) {
        if (overflowCount <= 0)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-avatar size="32" shape="circle">+${overflowCount}</mm-avatar>
    `;
    }
    renderLabel() {
        if (!this.label)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-text class="label">${this.label}</mm-text>
    `;
    }
};
AvatarGroup.styles = (0, lit_1.css) `
    :host {
      display: inline-flex;
      align-items: center;
      gap: var(--space-2);
      border-radius: var(--radius);
    }

    .avatars {
      display: flex;
    }

    .avatars > * {
      margin-left: -6px;
      outline: 4px solid var(--background-color);
    }

    .avatars > *:first-child {
      margin-left: 0;
    }

    .label {
      font-size: var(--font-size-14);
      line-height: var(--size-24);
      color: var(--foreground-color);
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ attribute: false })
], AvatarGroup.prototype, "avatars", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], AvatarGroup.prototype, "label", void 0);
AvatarGroup = __decorate([
    (0, decorators_js_1.customElement)('mm-avatar-group')
], AvatarGroup);
exports.AvatarGroup = AvatarGroup;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXZhdGFyLWdyb3VwLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiYXZhdGFyLWdyb3VwLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUFvRDtBQUNwRCxxREFBMkQ7QUFFM0QsNkNBQTBDO0FBQzFDLDREQUF5RDtBQUN6RCx5Q0FBc0M7QUFTL0IsSUFBTSxXQUFXLEdBQWpCLE1BQU0sV0FBWSxTQUFRLGdCQUFVO0lBQXBDOztRQTRCMkIsWUFBTyxHQUFpQixFQUFFLENBQUE7UUFDOUIsVUFBSyxHQUFHLEVBQUUsQ0FBQTtRQUN0QyxrQ0FBa0M7UUFDakIsZUFBVSxHQUFHLENBQUMsQ0FBQTtJQXdDakMsQ0FBQztJQXRDQyxNQUFNO1FBQ0osTUFBTSxhQUFhLEdBQUcsSUFBSSxDQUFDLE9BQU8sQ0FBQyxNQUFNLEdBQUcsSUFBSSxDQUFDLFVBQVUsQ0FBQTtRQUUzRCxPQUFPLElBQUEsVUFBSSxFQUFBOzZCQUNjLElBQUksQ0FBQyxnQkFBZ0IsQ0FBQyxhQUFhLENBQUM7UUFDekQsSUFBSSxDQUFDLFdBQVcsRUFBRTtLQUNyQixDQUFBO0lBQ0gsQ0FBQztJQUVPLGdCQUFnQixDQUFDLGFBQXFCO1FBQzVDLE9BQU8sQ0FBQyxJQUFJLENBQUMsYUFBYSxFQUFFLEVBQUUsSUFBSSxDQUFDLGNBQWMsQ0FBQyxhQUFhLENBQUMsQ0FBQyxDQUFBO0lBQ25FLENBQUM7SUFFTyxhQUFhO1FBQ25CLE9BQU8sSUFBSSxDQUFDLE9BQU8sQ0FBQyxLQUFLLENBQUMsQ0FBQyxFQUFFLElBQUksQ0FBQyxVQUFVLENBQUMsQ0FBQyxHQUFHLENBQUMsTUFBTSxDQUFDLEVBQUUsQ0FBQyxJQUFJLENBQUMsWUFBWSxDQUFDLE1BQU0sQ0FBQyxDQUFDLENBQUE7SUFDeEYsQ0FBQztJQUVPLFlBQVksQ0FBQyxFQUFFLElBQUksRUFBRSxHQUFHLEVBQWM7UUFDNUMsT0FBTyxJQUFBLFVBQUksRUFBQTt3Q0FDeUIsSUFBSSxJQUFJLEVBQUUsU0FBUyxHQUFHO0tBQ3pELENBQUE7SUFDSCxDQUFDO0lBRU8sY0FBYyxDQUFDLGFBQXFCO1FBQzFDLElBQUksYUFBYSxJQUFJLENBQUM7WUFBRSxPQUFPLGFBQU8sQ0FBQTtRQUV0QyxPQUFPLElBQUEsVUFBSSxFQUFBOzZDQUM4QixhQUFhO0tBQ3JELENBQUE7SUFDSCxDQUFDO0lBRU8sV0FBVztRQUNqQixJQUFJLENBQUMsSUFBSSxDQUFDLEtBQUs7WUFBRSxPQUFPLGFBQU8sQ0FBQTtRQUUvQixPQUFPLElBQUEsVUFBSSxFQUFBOytCQUNnQixJQUFJLENBQUMsS0FBSztLQUNwQyxDQUFBO0lBQ0gsQ0FBQzs7QUFyRU0sa0JBQU0sR0FBRyxJQUFBLFNBQUcsRUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7R0EwQmxCLENBQUE7QUFDK0I7SUFBL0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsU0FBUyxFQUFFLEtBQUssRUFBRSxDQUFDOzRDQUEyQjtBQUM5QjtJQUEzQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLENBQUM7MENBQVc7QUE3QjNCLFdBQVc7SUFEdkIsSUFBQSw2QkFBYSxFQUFDLGlCQUFpQixDQUFDO0dBQ3BCLFdBQVcsQ0F1RXZCO0FBdkVZLGtDQUFXIn0=